import { Skeleton } from '@reveni-io/reveni-ui'

import { parcelPresentationTypes } from '../hooks/useParcelsPresentationType/constants'
import { tableColumns } from './constants'
import * as Styles from './styles'

const ParcelsListPageSkeleton = ({ presentationType }) => {
  if (presentationType === parcelPresentationTypes.list) {
    return (
      <Styles.TableContainer>
        <Styles.Table>
          <Styles.TableHeader>
            <tr>
              {tableColumns.map(column => (
                <Styles.TableHeaderCell key={column.id}>
                  {!column.isIcon && <Skeleton variant="rounded" width={column.headerWidth} height={16} />}
                </Styles.TableHeaderCell>
              ))}
            </tr>
          </Styles.TableHeader>
          <Styles.TableBody>
            {Array.from({ length: 10 }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {tableColumns.map(column => (
                  <Styles.TableCell key={column.id}>
                    <Skeleton
                      variant={column.isIcon ? 'circular' : 'rounded'}
                      width={column.width}
                      height={column.height}
                    />
                  </Styles.TableCell>
                ))}
              </tr>
            ))}
          </Styles.TableBody>
        </Styles.Table>
      </Styles.TableContainer>
    )
  }

  return (
    <Styles.CardsContainer>
      {Array.from({ length: 5 }).map((_, index) => (
        <Styles.CardContainer key={index}>
          <Styles.CardHeader>
            <Styles.CardHeaderLeft>
              <Skeleton variant="rounded" width={20} height={20} />
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="rounded" width={80} height={20} />
              <Skeleton variant="rounded" width={20} height={14} />
            </Styles.CardHeaderLeft>
            <Styles.CardHeaderRight>
              <Skeleton variant="rounded" width={140} height={20} />
              <Skeleton variant="rounded" width={90} height={24} />
            </Styles.CardHeaderRight>
          </Styles.CardHeader>
          <Styles.CardBody>
            <Styles.CardBodyColumn alignItems="flex-start">
              <Skeleton variant="text" width={220} height={16} />
              <Skeleton variant="text" width={180} height={16} />
              <Skeleton variant="text" width={140} height={14} />
            </Styles.CardBodyColumn>
            <Styles.CardBodyColumn alignItems="flex-end">
              <Skeleton variant="text" width={120} height={16} />
              <Skeleton variant="text" width={100} height={16} />
              <Skeleton variant="text" width={80} height={14} />
            </Styles.CardBodyColumn>
          </Styles.CardBody>
        </Styles.CardContainer>
      ))}
    </Styles.CardsContainer>
  )
}

export default ParcelsListPageSkeleton
